import script from "./EditProfileForm.vue?vue&type=script&setup=true&lang=js"
export * from "./EditProfileForm.vue?vue&type=script&setup=true&lang=js"

import "./EditProfileForm.vue?vue&type=style&index=0&id=25899704&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25899704"]])

export default __exports__